//export const url = 'http://127.0.0.1:8000/api';
//export const url = 'http://api.kaproscm.peo.ba:8444/api';
export const url = "https://mini-api.kaproscm.com/api";